module.exports = __webpack_public_path__ + "media/newstyle/images/room-circle-44c3be1e9f0f78240c3b39a5a03ac596.svg";